import {css} from '@emotion/react'
import {Button, Modal} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

const useReplace = () => {
    const map = useMapContext()

    return (nodeIds, pattern, replacement) => {
        const replace = (s) => s.replaceAll(
            pattern,
            replacement.replaceAll('$', '$$$$'),
        )

        const nodes = nodeIds
            .map(
                (id) => map.getNode(id)
            )
            .filter(
                node => {
                    const n = map.nodeProxy(node)
                    return n.canWriteData()
                }
            )

        map.commands.updateNodeData(
            nodes,

            node => {
                const n = map.nodeProxy(node)
                return n.mapReplaceTextData(replace)
            }
        )
    }
}

const cssButtons = css({
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
})

const ButtonReplace = ({
    disabled,
    targetId,
    textReplace,
    textSearch,
    ...props
}) => {
    const replace = useReplace()

    const handleClick = () => {
        replace([targetId], textSearch, textReplace)
    }

    return (
        <Button
            disabled={disabled || ! targetId}
            size="small"
            onClick={handleClick}
            {...props}
        >
            替换
        </Button>
    )
}

const ButtonReplaceAll = ({
    matchedIds,
    textReplace,
    textSearch,
    ...props
}) => {
    const replace = useReplace()

    const handleClick = () => {
        const replaceAll = () => {
            replace(matchedIds, textSearch, textReplace)
        }

        Modal.confirm({
            content: '确定要全部替换？',
            onOk: replaceAll,
        })
    }

    return (
        <Button
            size="small"
            onClick={handleClick}
            {...props}
        >
            全部替换
        </Button>
    )
}

const ButtonsReplace = ({
    matchedIds,
    targetId,
    textReplace,
    textSearch,
    ...props
}) => {
    const map = useMapContext()
    const permission = map.usePermission()

    if (! (
        textSearch &&
        permission.has('write')
    )) {
        return null
    }

    const disabled = textSearch === textReplace

    return (
        <div
            css={cssButtons}
            {...props}
        >
            <ButtonReplace
                disabled={disabled}
                targetId={targetId}
                textReplace={textReplace}
                textSearch={textSearch}
            />

            <ButtonReplaceAll
                disabled={disabled}
                matchedIds={matchedIds}
                textReplace={textReplace}
                textSearch={textSearch}
            />
        </div>
    )
}

export default ButtonsReplace
